'use client';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';

export interface FlexibleFormFieldMetadata {
    type: string;
    fieldName: string;
    displayName: string;
    label: string;
}

export function normalizeFlexibleFormFieldKey(value?: string) {
    return `${value || ''}`.toLowerCase().replace(/[^a-z0-9]/g, '');
}

export function getFlexibleFormFieldMetadata(field: SiteFormField): FlexibleFormFieldMetadata {
    return {
        type: normalizeFlexibleFormFieldKey(field.fields.type),
        fieldName: normalizeFlexibleFormFieldKey(field.fields.field_name),
        displayName: normalizeFlexibleFormFieldKey(field.fields.name),
        label: normalizeFlexibleFormFieldKey(field.fields.label ? documentToPlainTextString(field.fields.label) : ''),
    };
}

export function findFlexibleFormField(
    formFields: SiteFormField[],
    matcher: (metadata: FlexibleFormFieldMetadata) => boolean,
) {
    return formFields.find((field) => matcher(getFlexibleFormFieldMetadata(field)));
}
